import { useEffect, useState } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import '../styles/Login.css'
import { useMutation } from "@tanstack/react-query";
import { createUser, generateOtp, verifyOtp } from "../services/authApi";
import Layout from "../components/Layout";
import Input from "../components/Input";

const Register = () => {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [otp, setOtp] = useState("");
  const [message, setMessage] = useState("");
  const [isOtpAvailable, setOtpAvailability] = useState(false);
  const [isPasswordForm, setIsPasswordForm] = useState(false);
  // otp related 
  const [secondsLeft, setSecondsLeft] = useState(0);



  const navigate = useNavigate();

  const generateOtpMutation = useMutation({
    mutationFn: generateOtp,
    onSuccess: (data) => {
      setMessage(data.otpSentTo)
      localStorage.setItem("signupForm", JSON.stringify(data.signupForm))
      setSecondsLeft(120)
      setOtpAvailability(true);
    },
  });

  const verifyMutation = useMutation({
    mutationFn: verifyOtp,
    onSuccess: (data) => {
      setOtp("")
      setOtpAvailability(false);
      setIsPasswordForm(true)
    },
  });

  const signupMutation = useMutation({
    mutationFn: createUser,
    onSuccess: (data) => {
      localStorage.removeItem("signupForm")
      setIsPasswordForm(false)
      navigate("/login")
    },
  });

  const signupFormHandler = (e) => {
    e.preventDefault()
    generateOtpMutation.mutate({
      name,
      email
    })
  }

  const handleVarify = (e) => {
    e.preventDefault();
    if (otp.length !== 4) {
      alert("Enter 4-digit OTP");
      return;
    }
    const formData = JSON.parse(localStorage.getItem("signupForm"))
    verifyMutation.mutate({
      email: formData.email,
      otp
    });
  };

  const signHandler = (e) => {
    e.preventDefault()
    const formData = JSON.parse(localStorage.getItem("signupForm"))
    signupMutation.mutate({
      name: formData.name,
      email: formData.email,
      password,
    })
  }
  const handleSendOtp = async () => {
    const formData = JSON.parse(localStorage.getItem("signupForm"))
    generateOtpMutation.mutate({ name: formData.name, email: formData.email })       // your API call
    setSecondsLeft(120);       // 60 seconds cooldown
  };

  useEffect(() => {
    if (secondsLeft === 0) return;

    const timer = setInterval(() => {
      setSecondsLeft((prev) => prev - 1);
    }, 1000);

    return () => clearInterval(timer);
  }, [secondsLeft]);

  return (
    <Layout>
      <div className="login" >
        <h1 style={{ margin: "0px auto" }}>Sign up</h1>
        <br />
        {(!isOtpAvailable && !isPasswordForm) && <form onSubmit={signupFormHandler}>
          <button
            className="googleBtn"
            onClick={() =>
              window.location.href =
              // "http://localhost:5000/api/auth/google"
              "https://mern-bookstore-backend-o6qf.onrender.com/api/auth/google?redirect=store"
            }
          >
            <img
              src="https://developers.google.com/identity/images/g-logo.png"
              alt="Google"
              width="18"
            />
            Continue with Google
          </button>
          <br />
          <p style={{ margin: "0px auto", color: "#555" }}>or</p>
          <Input type={"text"} name={name} placeholder={"Name"} value={name} onChange={(e) => setName(e.target.value)} maxLength={40} />
          <Input type={"email"} name={email} placeholder={"Email"} value={email} onChange={(e) => setEmail(e.target.value)} />
          <br />
          {generateOtpMutation.error && (
            <><p style={{ color: "red", margin: "0px auto" }}>{generateOtpMutation.error.message} </p><br /></>
          )}
          <button
            type="submit"
            disabled={generateOtpMutation.isPending}
          >
            {generateOtpMutation.isPending ? "Continue" : "Continue"}
          </button>
          <br />
          <p style={{ margin: "0px auto", color: "#999" }}>Already have account ?</p>
          <NavLink to={'/login'} style={{ margin: "0px auto", color: "var(--primary-color)" }}>Log In</NavLink>

        </form>}
        {/* otp Form */}
        {(isOtpAvailable && !isPasswordForm) && <form onSubmit={handleVarify}>
          <p style={{ color: "#555", fontSize: ".85rem" }}>An OTP has been sent to your registered email
            <span style={{ fontStyle: "italic", color: "#555" }}> {message}</span>
          </p>
          <br />
          <p>Verify OTP</p>
          <Input type={"number"} name={otp} placeholder={"Enter OTP"} value={otp} onChange={(e) => setOtp(e.target.value.replace(/\D/g, ""))} maxLength={4} />
          <span
            onClick={handleSendOtp}
            style={{ fontSize: "0.8rem", color: secondsLeft > 0 ? "#777" : "var(--primary-color)", cursor: "pointer" }}
            disabled={secondsLeft > 0}
          >
            {secondsLeft > 0
              ? `${secondsLeft}`
              : " Resend OTP"}
          </span>
          <br />
          {generateOtpMutation.error && (
            <p style={{ color: "red", margin: "0px auto" }}>{generateOtpMutation.error.message}</p>
          )}
          {verifyMutation.error && <><p style={{ color: "red" }}>{verifyMutation.error.message}</p><br /></>}
          <button
            type="submit"
            disabled={verifyMutation.isPending}
          >{verifyMutation.isPending ? "Verifying" : "Verify OTP"}
          </button>
          <br />
          <p style={{ color: "#333" }}>This code is valid for 5 minutes only.</p>

        </form>}

        {(!isOtpAvailable && isPasswordForm) && <form onSubmit={signHandler}>
          <p style={{ color: "#555", fontSize: ".85rem" }} >Create password</p>
          <Input type={"password"} name={password} placeholder={"Password"} value={password} onChange={(e) => setPassword(e.target.value)} minLength={6} />
          <br />

          {signupMutation.error && (<><p style={{ color: "red" }}>{signupMutation.error.message}</p><br /></>)}

          <button
            type="submit"
            disabled={signupMutation.isPending}
          >
            {signupMutation.isPending ? "Signing up..." : "Sign up"}
          </button>


        </form>}
      </div>
    </Layout>
  );
};

export default Register;
